import {CanActivateChildFn, CanActivateFn} from "@angular/router";
import {inject} from "@angular/core";
import {FirebaseAuthenticationService} from "./firebase/firebase-authentication.service";
import {LoginModalService} from "./login/login-modal/login-modal.service";
import {map} from "rxjs";

export const authenticationGuard: CanActivateFn = (route, state) => {
  const authenticationService = inject(FirebaseAuthenticationService);
  const loginModalService = inject(LoginModalService);

  return authenticationService
    .isAuthenticated()
    .pipe(
      map((isAuthenticated => {
        if (!isAuthenticated) {
          // loginModalService.showModal();
          loginModalService.loginAndRoute(state.url);
        }
        return isAuthenticated;
      }))
    )
}

export const authenticationGuardChild: CanActivateChildFn = (route, state) => authenticationGuard(route, state);
